
/* afx-moq.js v4 — Order increment enforcement for Empire theme */
(function(){
  var dataEl = document.querySelector('[data-section-type="static-product"][data-section-data]');
  if (!dataEl) return;
  var sectionData;
  try { sectionData = JSON.parse(dataEl.textContent); } catch(e) { return; }
  if (!sectionData || !sectionData.product) return;
  var product = sectionData.product;
  var INC = 0;

  /* Read from badge attribute (most reliable) */
  var badge = document.querySelector('[data-moq-increment]');
  if (badge) INC = parseInt(badge.getAttribute('data-moq-increment'), 10) || 0;

  /* Fallback: check product tags for increment:N */
  if (!INC && product.tags) {
    var tags = typeof product.tags === 'string' ? product.tags.split(',') : product.tags;
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].trim().match(/^increment:(\d+)$/);
      if (m) { INC = parseInt(m[1], 10); break; }
    }
  }
  if (INC <= 1) return;

  function snap(v) {
    v = parseInt(v, 10) || 0;
    if (v < INC) return INC;
    return v % INC === 0 ? v : Math.ceil(v / INC) * INC;
  }

  function init() {
    var inp = document.querySelector(
      '.element-quantity-selector__input, .quantity-selector__input, input[name="quantity"], [data-quantity-input]'
    );
    if (!inp) return;

    /* Set initial value */
    inp.value = INC;
    inp.setAttribute('min', INC);

    var qs = inp.closest('quantity-selector');

    function patchQS(el) {
      if (!el || el.__moqPatched) return;
      el.__moqPatched = true;

      /* Replace the plus/minus click handlers entirely */
      var plus = el.querySelector('.element-quantity-selector__button--plus, .quantity-selector__button--plus, [data-quantity-plus]');
      var minus = el.querySelector('.element-quantity-selector__button--minus, .quantity-selector__button--minus, [data-quantity-minus]');
      var elInput = el.querySelector('input');

      if (plus) {
        plus.addEventListener('click', function(e) {
          e.stopImmediatePropagation();
          var cur = parseInt(elInput.value, 10) || INC;
          var next = cur + INC;
          elInput.value = next;
          el.style.setProperty('--digit-count', next.toString().length + 'ch');
          elInput.dispatchEvent(new Event('input', { bubbles: true }));
        }, true);
      }

      if (minus) {
        minus.addEventListener('click', function(e) {
          e.stopImmediatePropagation();
          var cur = parseInt(elInput.value, 10) || INC;
          var next = Math.max(INC, cur - INC);
          elInput.value = next;
          el.style.setProperty('--digit-count', next.toString().length + 'ch');
          elInput.dispatchEvent(new Event('input', { bubbles: true }));
        }, true);
      }

      /* Also set minValue so the component doesn't interfere */
      el.minValue = INC;

      /* Set initial value through the input */
      elInput.value = INC;
      el.style.setProperty('--digit-count', INC.toString().length + 'ch');
    }

    /* Wait for web component to be defined */
    if (qs) {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('quantity-selector').then(function() { patchQS(qs); });
      }
      var retries = 0;
      var tm = setInterval(function() {
        if (qs && qs.querySelector('input')) { patchQS(qs); clearInterval(tm); }
        if (++retries > 50) clearInterval(tm);
      }, 100);
    }

    /* Enforce on blur/change as safety net */
    function enforce() {
      var raw = parseInt(inp.value, 10) || 0;
      var fixed = snap(raw);
      if (raw !== fixed) inp.value = fixed;
    }
    inp.addEventListener('change', enforce);
    inp.addEventListener('blur', enforce);

    /* Intercept form submit */
    var form = inp.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        var raw = parseInt(inp.value, 10) || 0;
        if (raw < INC || raw % INC !== 0) {
          inp.value = snap(raw);
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    }
  }

  /* Override fetch for AJAX add-to-cart */
  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts && opts.body) {
      try {
        var b = typeof opts.body === 'string' ? JSON.parse(opts.body) : null;
        if (b && b.quantity) {
          b.quantity = snap(parseInt(b.quantity, 10));
          opts.body = JSON.stringify(b);
        }
      } catch(e) {}
    }
    return origFetch.apply(this, arguments);
  };

  /* Override XMLHttpRequest */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, u) { this._moqUrl = u; return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._moqUrl && this._moqUrl.indexOf('/cart/add') !== -1 && body) {
      try { var p = JSON.parse(body); if (p && p.quantity) { p.quantity = snap(parseInt(p.quantity, 10)); body = JSON.stringify(p); } } catch(e) {}
    }
    return origSend.call(this, body);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
